import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { formatDistanceToNow } from 'date-fns';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentPurchases } from '../../data/recentPurchases';
import { heroMockupUrl } from '../../data/offer';
const FIRST_DELAY = 8000;
const VISIBLE_FOR = 5000;
const GAP = 12000;
export function PurchaseNotification() {
  const [index, setIndex] = useState<number | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed || recentPurchases.length === 0) return;
    const timers: ReturnType<typeof setTimeout>[] = [];
    recentPurchases.forEach((_, i) => {
      const start = FIRST_DELAY + i * (VISIBLE_FOR + GAP);
      timers.push(setTimeout(() => setIndex(i), start));
      timers.push(setTimeout(() => setIndex(null), start + VISIBLE_FOR));
    });
    return () => timers.forEach(clearTimeout);
  }, [dismissed]);
  if (recentPurchases.length === 0) return null;
  const purchase = index !== null ? recentPurchases[index] : null;
  return <div aria-live="polite" className="pointer-events-none fixed bottom-24 left-3 z-40 sm:left-5" data-id="element-222" data-mp="3qyrthby8p88i">
      <AnimatePresence data-id="element-223" data-mp="3m56vhjwnce9b">
        {purchase && !dismissed && <motion.div key={index} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-[19rem] max-w-[calc(100vw-1.5rem)] items-center gap-3 rounded-xl border border-forest/10 bg-white p-3 pr-9 shadow-[0_20px_40px_-16px_rgba(9,40,29,0.45)]" data-id="element-224" data-mp="3i4n12o3gjoqv">
            <img src={heroMockupUrl} alt="" width={56} height={56} className="h-14 w-14 shrink-0 rounded-lg bg-onyx object-cover" data-id="element-225" data-mp="11epxivjj8n78" />
            <div className="min-w-0" data-id="element-226" data-mp="2qxo655dlym11">
              <p className="truncate text-sm font-semibold text-forest" data-id="element-227" data-mp="2qwmuayorpvi9">
                {purchase.firstName} <span className="font-normal text-forest/60" data-id="element-228" data-mp="2vpo8t5l2bt1b">from {purchase.location}</span>
              </p>
              <p className="text-sm text-forest/80" data-id="element-229" data-mp="2hz2nla84z709">
                bought <span className="font-semibold text-gold-dark" data-id="element-230" data-mp="2lybjolqnfgyz">HYROX Mega Pack</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-forest/55" data-id="element-231" data-mp="39ofo2vbnvkr1">
                <CheckCircle2Icon aria-hidden="true" className="h-3.5 w-3.5 text-cta" data-id="element-232" data-mp="3eoadeufsg29z" />
                {formatDistanceToNow(new Date(purchase.purchasedAt), {
              addSuffix: true
            })}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Hide purchase notifications" className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md text-forest/50 transition-colors duration-150 ease-out hover:bg-mint hover:text-forest focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-233" data-mp="35matnude2k3c">
              <XIcon aria-hidden="true" className="h-4 w-4" data-id="element-234" data-mp="1hojkljk61zed" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}